export default "__VITE_ASSET__BNNNEfOy__"